module.exports = __webpack_public_path__ + "assets/img/bg_1-zi.2f71daa5.png";